"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = __importDefault(require("../../client"));
function recruitementReport({ token, id, }) {
    const userId = id.split(':')[1];
    return client_1.default.get(`/user/${userId}/report`, {
        headers: {
            Authorization: token,
        },
    });
}
exports.default = recruitementReport;
